export const accountTypeList = [{name: 'REAL'},{name: 'DEMO'}];

